import Journey from '../components/Journey'
import GLP1Info from '../components/GLP1Info'
import HowItWorks from '../components/HowItWorks'
import Results from '../components/Results'
import BeforeAfter from '../components/BeforeAfter'
import FAQ from '../components/FAQ'
import ContactForm from '../components/ContactForm'
import CTA from '../components/CTA'
import Footer from '../components/Footer'
import PillNav from '../components/PillNav'

const MainContent = () => {
  const pillNavItems = [
    { label: 'Home', href: '/', ariaLabel: 'Go to home page' },
    { label: 'Longevity', href: '/main', ariaLabel: 'Go to longevity page' },
    { label: 'Travel', href: 'https://andreavillalobos.inteletravel.com/booktravel.cfm', ariaLabel: 'Book your trip' },
  ]

  const logoUrl = '/favicon.ico'

  return (
    <div className="relative min-h-screen bg-[#cdfbf1] text-slate-900 overflow-hidden">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.9),_rgba(205,251,241,0.8))]" />
      <div
        className="pointer-events-none absolute inset-y-0 left-1/2 w-[70vw] -translate-x-1/2 blur-[100px] opacity-70"
        style={{ background: 'linear-gradient(120deg, rgba(205,251,241,0.8), rgba(255,255,255,0.6))' }}
      />

      <PillNav
        logo={logoUrl}
        logoAlt="Logo"
        items={pillNavItems}
        activeHref="/main"
        baseColor="#cdfbf1"
        pillColor="#067c79"
        pillTextColor="#ffffff"
        hoveredPillTextColor="#063131"
        className="md:right-6"
        initialLoadAnimation={true}
      />

      <main className="relative z-10 flex flex-col gap-0">
        <Journey />
        <GLP1Info />
        <HowItWorks />
        <Results />
        <BeforeAfter />
        <FAQ />
        <ContactForm />
        <CTA />
        <Footer />
      </main>
    </div>
  )
}

export default MainContent
